<template>
  <div
    role="button"
    tabindex="0"
    :disabled="isDisabled"
    :aria-disabled="isDisabled"
    :class="
      isDisabled
        ? 'bg-velux-grey-300 text-velux-grey-900 pointer-events-none'
        : 'bg-velux-red text-velux-white hover:bg-velux-hover-red'
    "
    class="
      w-full
      transition-colors
      flex
      md:text-xl
      items-center
      justify-center
      md:w-auto md:inline-flex
      py-3.5
      md:py-3
      px-7
      font-bold
      md:mt-5
    "
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>
